import TableEmpyArea from 'pages/import/TableEmptyArea';
import React from 'react';
import theme from 'source/theme';
// Bundled, like the two on the other import screen. They used to be links into
// somebody's Google Drive, which is a different problem wearing the same shape
// as a template: the file behind a Drive link can change without the code
// changing, and nobody here can tell which version a customer downloaded. These
// are versioned with the code that reads them, so a column the importer expects
// and a column the file has move together or not at all.
import autorizacoesTemplate from 'templates/autorizacoes.xlsx';
import restricoesTemplate from 'templates/restricoes.xlsx';
import svhcTemplate from 'templates/svhc.xlsx';
import { TABLE_HEIGHT } from 'utils/ui/constants';

const TABLE_HEIGHT_CUSTOM = TABLE_HEIGHT(true, 71);

export default () =>
  <TableEmpyArea bodyHeight={TABLE_HEIGHT_CUSTOM}>
    <div>
      <p>
        Nesta área pode importar ficheiros XLSX de dados relacionados com
        as ECHAs: restrições, svhc e autorizações.
      </p>
      <p>
        Abaixo tem exemplos de ficheiros de importação:
      </p>
      <ul>
        <li>
          <a
            href={restricoesTemplate}
            download="restricoes.xlsx"
            style={{ color: theme.palette.primary.main }}
          >
            Template XLSX Restrições
          </a>
        </li>
        <li>
          <a
            href={svhcTemplate}
            download="svhc.xlsx"
            style={{ color: theme.palette.primary.main }}
          >
            Template XLSX SVHC
          </a>
        </li>
        <li>
          <a
            href={autorizacoesTemplate}
            download="autorizacoes.xlsx"
            style={{ color: theme.palette.primary.main }}
          >
            Template XLSX Autorizações
          </a>
        </li>
      </ul>
    </div>
  </TableEmpyArea>;
